import has from 'lodash/has';
import { isAdminAccess, isManagedResource, isReadOnly } from 'js/lib/ACLUtils';
import { getConnectionOrVendorType } from 'js/lib/ResourceUtils';

export const mapStateToProps = (state, ownProps) => {
  const {
    sources: { summaryById },
    entities: { users, vendors },
  } = state;
  const { cardData } = ownProps;
  const readOnly = isReadOnly(cardData);
  const isManaged = isManagedResource(cardData);
  const adminAccess = isAdminAccess(cardData);

  const connectionOrVendorType = getConnectionOrVendorType(
    cardData,
    vendors,
    'source_type',
    'vendor_id',
  );

  const owner = has(cardData, 'owner') && has(users, cardData.owner) ? users[cardData.owner] : null;
  return {
    readOnly,
    isManaged,
    adminAccess,
    connectionOrVendorType,
    owner,
    summaryData: cardData && has(summaryById, cardData.id) ? summaryById[cardData.id] : null,
  };
};
